import {
    authConstants
  } from "./../constants/auth-constants";
  

  const initialState = {
    agentList: []
  };
  function agentsReducer(state  = initialState, action) {
    console.log(action)
    switch (action.type) {
      case authConstants.AGENT_LIST:
        return {
            ...state,
            agentList: action.payload.data
          };

      default:
        return state ;
    }
  };
  
  export default agentsReducer;